import React, {Fragment} from 'react';
import {FormCheck} from 'react-bootstrap';
import {Glyphicon} from "../../../Common/GlyphIcon";
import {SpeciesListPicker} from "../../../../Models/Core/FieldEditors/SpeciesListFieldEditor";
import {useSelector} from "react-redux";
import {config} from "../../../../Config";
import {service as QueryToolService} from "../../../../Services/QueryToolService";
import {useHasColumns} from "../../../../Hooks/QueryToolDataHooks";
import {useClearFilters, useUpdateFilter} from "../../../../Hooks/QueryToolFilterHooks";
import DateUtils from "../../../../../../monitoring/src/Utils/DateUtils";
import {selectQueryDefinition} from "../../../../Redux/Selectors/queryToolSelectors";

export const QueryToolTableFilter = () => {
    const definition = useSelector(selectQueryDefinition);
    const updateFilter = useUpdateFilter();
    const clearFilters = useClearFilters();
    const hasColumns = useHasColumns();

    const {useGroupBy, useLocalTime, speciesListId, favorite, count, pageSize, page} = useSelector(state => state.queryToolState);

    const download = () => {
        const downloadName = favorite ? favorite.name : 'Query';
        const date = DateUtils.GetCurrentDateTime('yyyy-MM-dd-HHmmss');
        const env = config.getEnvironment() === 'prod' ? '' : ` - ${config.getEnvironment()}`;

        QueryToolService.DownloadFile(`StreamBank - ${downloadName} - ${date}${env}.xlsx`, definition);
    };

    const renderResults = () => {
        const total = count;
        const countFrom = page * pageSize + 1;
        const countTo = Math.min((page + 1) * pageSize, total);

        if (total === 0) {
            return null;
        }

        return (
            <Fragment>
                <span className="sb-query-bold">{countFrom}</span>-<span className="sb-query-bold">{countTo}</span> of <span className="sb-query-bold">{total} results</span>
            </Fragment>
        );
    };

    return (
        <div className="sb-query-toolbar">
            <span className="sb-query-results">
                {renderResults()}
            </span>
            <span className="sb-query-filter-options">
                <span className="filter-items dropdown-filter-item">
                    <label>Species List</label>
                    <SpeciesListPicker
                        id="species-list-id"
                        label="Species List"
                        className="filter-items"
                        value={speciesListId}
                        onChange={(value) => updateFilter('speciesListId', value)}
                    />
                </span>
                <FormCheck
                    id="use-group-by"
                    label="Use Group By"
                    checked={useGroupBy}
                    onChange={() => updateFilter('useGroupBy', !useGroupBy)}
                    className="filter-items"
                />
                <FormCheck
                    id="use-local-time"
                    label="Use Local Time"
                    checked={useLocalTime}
                    onChange={() => updateFilter('useLocalTime', !useLocalTime)}
                    className="filter-items"
                />
                {hasColumns && (
                    <Fragment>
                        <a onClick={() => clearFilters()} className="filter-items">
                            <Glyphicon glyph="remove-sign"/>
                            <span>Clear All Filters</span>
                        </a>
                        <a onClick={() => download()} className="filter-items">
                            <Glyphicon glyph="download"/>
                            <span>Download Data (.xls)</span>
                        </a>
                    </Fragment>
                )}
            </span>
        </div>
    );
};
